import { render, staticRenderFns } from "./SystemAnalysis.vue?vue&type=template&id=4afc4e22&scoped=true&"
import script from "./SystemAnalysis.vue?vue&type=script&lang=js&"
export * from "./SystemAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./SystemAnalysis.vue?vue&type=style&index=0&id=4afc4e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc4e22",
  null
  
)

export default component.exports